import { PostAlertsResponse } from '@api';

export const QUERY_KEY_EVENT_ALERTS = 'QUERY_KEY_EVENT_ALERTS';
export const QUERY_KEY_EVENT_ALERT_SUBSCRIPTION =
  'QUERY_KEY_EVENT_ALERT_SUBSCRIPTION';
export const getKgInsightSubscriptionQueryKey = (entityTag: string) =>
  [QUERY_KEY_EVENT_ALERT_SUBSCRIPTION, entityTag, 'kg-insight'] as const;
export const UNREAD_COUNT_QUERY_KEY = [
  QUERY_KEY_EVENT_ALERTS,
  { count_only: true, read: false },
];

export type EventAlertsPaginatedResponse = {
  pages: PostAlertsResponse[];
  pageParams: (string | null)[];
};
